import axiosInstanceClient from "../Common/Axios/axiosInstanceClient";
import API from "../Common/Endpoint/serviceConstrants";

export const callBusinessUpdateApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.post(API.businessUpdate, payload);
  return data;
};

export const callGetBusinessApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.get(API.getBusiness, {
    params: payload,
  });
  return data;
};  

export const callVenueSaveApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.post(API.venueSave, payload);
  return data;
};

export const callGetVenueApi = async () => {
  const { data = {} } = await axiosInstanceClient.get(API.getVenue);
  return data;
};

export const callVenueImagesApi = async (businessId, formData) => {
  const { data = {} } = await axiosInstanceClient.post(
    `${API.venueSave}/${businessId}/images`,
    formData
  );
  return data;
};

export const callImagesUploadApi = async (formData, options = {}) => {
  const { imageId, businessId, imageType, displayOrder, isDeleted } = options;
  const isDeleteRequest = isDeleted === true && imageId != null;

  if (isDeleteRequest) {
    const deleteFormData = new FormData();
    deleteFormData.append("id", imageId);
    deleteFormData.append("isDeleted", "true");
    // if (businessId != null) deleteFormData.append("business_id", businessId);
    const { data = {} } = await axiosInstanceClient.post(
      API.imagesUpload,
      deleteFormData,
      { headers: { "Content-Type": undefined } }
    );
    return data;
  }

  const hasFile = formData.get("image") instanceof File;
  if (!hasFile) {
    throw new Error("FormData must include a file (field 'file' or 'image')");
  }
  if (imageId != null) formData.append("id", imageId);
  if (businessId != null) formData.append("business_id", businessId);
  if (imageType != null) formData.append("image_type", imageType);
  if (displayOrder != null) formData.append("display_order", displayOrder);
  const { data = {} } = await axiosInstanceClient.post(
    API.imagesUpload,
    formData,
    {
      headers: {
        "Content-Type": undefined,
      },
    }
  );
  return data;
};

export const callGetImagesApi = async (businessId) => {
  const { data = {} } = await axiosInstanceClient.get(API.getImages, {
    params: { business_id: businessId },
  });
  return data;
};

export const callEnquiryPostApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.post(API.enquiryPost, payload);
  return data;
};

export const callGetEnquiriesApi = async (params = {}) => {
  const { data = {} } = await axiosInstanceClient.get(API.getEnquiries, {
    params,
  });
  return data;
};

export const callUpdateEnquiryApi = async (payload) => {
  const { id, ...rest } = payload;
  const { data = {} } = await axiosInstanceClient.post(API.enquiryUpdate, {
    id,
    ...rest,
  });
  return data;
};

export const callEnquiryViewApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.post(API.enquiryView, payload);
  return data;
};

/**
 * POST /api/reviews – submit a review (payload: entityType, entityId, rating, reviewText or as per backend).
 */
export const callReviewPostApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.post(API.reviewPost, payload);
  return data;
};

export const callGetReviewsApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.get(API.reviewPost, {
    params: payload,
  });
  return data;
};

export const callVendorPostApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.post(API.vendorPost, payload);
  return data;
};

export const callGetVendorsApi = async (params = {}) => {
  const { data = {} } = await axiosInstanceClient.get(API.getVendors, {
    params,
  });
  return data;
};

export const callVendorProfileSaveApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.post(API.vendorPost, payload);
  return data;
};

export const callGetVendorProfileApi = async () => {
  const { data = {} } = await axiosInstanceClient.get(API.getVendorProfile);
  return data;
};

/**
 * POST /api/mail/send – send mail (payload: to, subject, body, etc. as per backend).
 */
export const callSendMailApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.post(API.sendMail, payload);
  return data;
};

export const callGetRealWeddingsApi = async (params = {}) => {
  const { data = {} } = await axiosInstanceClient.get(API.getRealWeddings, {
    params,
  });
  return data;
};

export const callGetRealWeddingApi = async (id) => {
  const url = typeof API.getRealWedding === "function" ? API.getRealWedding(id) : `${API.getRealWeddings}/${id}`;
  const { data = {} } = await axiosInstanceClient.get(url);
  return data;
};

export const callRealWeddingPostApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.post(API.realWeddingsPost, payload);
  return data;
};

/**
 * POST real wedding as FormData.
 * formData should contain: heading, description, wedding_photos[0][image], wedding_photos[0][type], ...
 */
export const callRealWeddingPostFormDataApi = async (formData) => {
  const { data = {} } = await axiosInstanceClient.post(API.realWeddingsPost, formData, {
    headers: { "Content-Type": undefined },
  });
  return data;
};

/**
 * PUT real wedding update as FormData. id in URL.
 */
export const callRealWeddingUpdateFormDataApi = async (id, formData) => {
  const url = typeof API.realWeddingUpdate === "function" ? API.realWeddingUpdate(id) : `${API.realWeddingsPost}/${id}`;
  const { data = {} } = await axiosInstanceClient.post(url, formData, {
    headers: { "Content-Type": undefined },
  });
  return data;
};